import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/5m2Ybeyf59hGaxGvneUz2z/Pasukan_Pengamanan_Presiden_(1).png';
export function PaspampresLogo({
  className = '',
  size = 32,
  alt = 'Lambang Paspampres — Setia Waspada'
}: {
  className?: string;
  size?: number;
  alt?: string;
}) {
  return <img src={LOGO_URL} alt={alt} width={size} height={size} className={`object-contain select-none ${className}`} draggable={false} data-id="element-796" />;
}